import { appConfig as $config } from '../../app.config';
import { App } from '../../modules/App';
import { Common } from '../../modules/Common';
import { UI } from '../../modules/UI';
import { User } from '../../modules/User';
import { SortFilter } from '../../modules/SortFilter';
import { ColorCarousel } from '../../modules/ColorCarousel';
import { MasterProductData } from '../../modules/MasterProductData';
import { ProductInfo } from '../../modules/ProductInfo';
import { ArtworkInfo } from '../../modules/ArtworkInfo';
import { BlankInfo } from '../../modules/BlankInfo';
import { BOM } from '../../modules/BOM';
import { MockupStatus, MockupSubmission, submissionDirectoryErrorModal } from '../../modules/ReactComponent';

import './scss/listings.scss';
import { QuickFilters } from '../../modules/SortFilter/quick-filters';

export const Listings = (function () {
  let lastQuery = {};
  let $isLicensor = '';

  let mapping = {
    listings: (data) => {
      return $.map(data, function (arts) {
        arts.imageExistsUri = arts.thumbnailImageUri
          ? arts.thumbnailImageUri
          : arts.variants.length > 0
          ? arts.variants[0].imageUri
          : '';
        arts.createDateText = moment(arts.stateChangedDate || arts.createdDate).format($config.appFullDateFormat);
        arts.startPrice = `${arts.defaultPrice.currencyValue} ${arts.defaultPrice.currencyCode}`;
        arts.priceDisplay = Common.priceRange(arts.priceRange);
        arts.assetsDisplay = arts.assets
          .map((art) => {
            return art.frameType === 0
              ? `<a href="javascript:" data-id="${art.objectId}" class="artwork-name">${art.title}</a>`
              : `${art.title}`;
          })
          .join(', ');
        arts.sizes = Common.sizeRange(arts.availableSizes);
        arts.approvedColorsOnly = true;
        arts.variants.forEach((col) => {
          col.disabled = true;
          return col;
        });
        if (arts.variants.length > $config.colorVariantsInCard) {
          arts.variants.length = $config.colorVariantsInCard;
          arts.variantsCut = true;
        }

        arts.productInStoresString = arts.productInStores
          .map((store) => {
            return store.productUrl
              ? `<a href="${store.productUrl}" target="_blank">${store.storeDisplayName || store.storeName}</a>`
              : store.storeDisplayName || store.storeName;
          })
          .join(', ');

        arts.totalSales =  arts.totalSales && arts.totalSales.currencyValue>0
            ? $config.currencySymbol[arts.totalSales.currencyCode?arts.totalSales.currencyCode:"USD"] +
              '' +
              arts.totalSales.currencyValue.toFixed(2)
            : '';

        updateSubmissionIndication(arts);

        return arts;
      });
    },
    folderDialog: (cardData, directory) => {
      const bomfolderproduct = directory === 'bomfolderproduct';

      const directoryName = bomfolderproduct ? 'BOM' : directory.replace('_log', '');
      const isDirectoryLog = directory.includes('_log');

      const folderData = cardData.submitStatusInformation.folderStatusInformations.find(
        (stat) => stat.directoryName === directoryName
      );
      if (!folderData) {
        return null;
      }

      const urls = {
        bomfolderproduct: 'SKUCatalog/get-bom-files-by-product',
        BOM: `SKUCatalog/get-bom-files-by-correlation/${folderData.correlationId}`,
        BOM_log: `ChangeTracker/get-bom-logs/${cardData.id}/${folderData.correlationId}`,
        RIP: `SKUCatalog/get-rip-items-by-correlation/${folderData.correlationId}`,
        RIP_log: `ChangeTracker/get-rip-logs/${directoryName}/${cardData.id}/${folderData.correlationId}`
      };

      const pages = {
        bomfolderproduct: 'MockupBomFolder',
        BOM: 'MockupBomFolder',
        BOM_log: 'MockupBomStatuses',
        RIP: 'MockupKsfFolder',
        RIP_log: 'MockupKsfStatuses'
      };

      return {
        accountId: User.accountID(),
        apiUrl: $config.apiURL,
        title: cardData.title,
        standartId: cardData.standartId,
        createdDate: folderData.createDate,
        id: cardData.id,
        requestId: bomfolderproduct ? cardData.id : null,
        urlPath: urls[directory] || (isDirectoryLog ? urls.RIP_log : urls.RIP),
        requestPageType: pages[directory] || (isDirectoryLog ? pages.RIP_log : pages.RIP),
        directoryName: directoryName,
        statusMessage: folderData.statusMessage,
        isKSF: directoryName !== 'BOM',
      };
    }
  };

  let updateSubmissionIndication = (v) => {
    let directoryName;

    (v?.submitStatusInformation?.folderStatusInformations || []).some((statusInformation) => {
      if (statusInformation.status === 3) { // error
        v.submissionIndicationText = statusInformation.statusMessage;
        v.submissionIndicationStatus = 'error';

        return true;
      }

      if (statusInformation.status === 1 || statusInformation.status === 2) { // success || warning
        if (v.submissionIndicationStatus !== 'success' && v.submissionIndicationStatus !== 'warning') {
          directoryName = '';
        }

        v.submissionIndicationStatus = v.submissionIndicationStatus !== 'warning' && statusInformation.status === 2 ? 'success' : 'warning';
        directoryName = directoryName ? `${directoryName}, ${statusInformation.directoryName}` : statusInformation.directoryName;

        return;
      }

      if (statusInformation.status === -1) { // in progress
        if (!v.submissionIndicationStatus || v.submissionIndicationStatus === 'inProgress') {
          if (v.submissionIndicationStatus !== 'inProgress') {
            directoryName = '';
          }

          v.submissionIndicationStatus = 'inProgress';
          directoryName = directoryName ? `${directoryName}, ${statusInformation.directoryName}` : statusInformation.directoryName;
        }

        return;
      }

      if (!v.submissionIndicationStatus) {
        directoryName = directoryName ? `${directoryName}, ${statusInformation.directoryName}` : statusInformation.directoryName;
      }
    });

    if (!directoryName) {
      return;
    }

    switch (v.submissionIndicationStatus) {
      case 'error':
        return;
      case 'warning':
      case 'success':
        v.submissionIndicationText = `${directoryName} submitted`;
        break;
      case 'inProgress':
        v.submissionIndicationText = `${directoryName} submission in process`;
        break;
      default:
        v.submissionIndicationText = `${directoryName} not submitted`;
    }
  };

  let init = (params = {}, query = '') => {
    if (params && params.action && params.id) {
      if (params.action == 'masterProductData') {
        return masterProductDataPage(params.id);
      }
    }

    if (isPostponedByLostSelectionDialog(params, query)) {
      return;
    }

    $isLicensor = User.isLicensor();

    QuickFilters.setSyncFilters({
      licensorFilters: ['Licensee', 'Brand', 'Subbrand', 'LicenseOwner'],
      licenseeFilters: ['Licensor', 'Brand', 'Subbrand'],
    });

    UI.block('#page');

    let requestData = {};

    lastQuery = { params: params, query: query, pagename: $lang.pagetitle.ListingsCatalog, pageurl: '/listings' };

    $.when(App.ajaxData(`listings/filter`, requestData, 'POST')).done((pageData) => {
      pageData.data = mapping.listings(pageData.data);
      pageData.isLicensor = $isLicensor;

      let template = require('./tmpl/listings.hbs');
      UI.page(template, pageData).then(() => {
        App.pageData('selectAllListing', false);
        App.pageData('selectListing', []);

        pageinit();
      });
    });
  };

  let pageinit = (pageReload = false) => {
    QuickFilters.init({ selector: '#listingsQuickFilters' });

    if (!pageReload) {
      SortFilter.init({ selector: '#searchForm', update: reloadPageWithClearingSelectAll });

      $('#page')
        .off()
        .on('dblclick', '.js-action-productInfo', productInfoDialog)
        .on('click', '.card-item-listing .artwork-name', artworkInfoDialog)
        .on('click', '.js-action-blankinfo', blankInfoDialog)
        .on('click', '.js-action-submitbom', handleBOMsubmit)
        .on('click', '.js-action-folderdialog', folderDialog)
        .on('click', '.js-downloadFilesForPersonalization', downloadFilesForPersonalization)
        .on('click', '.js-toggleState', moveToPrelistings)
        .on('click', '.js-action-toggleState', moveSelectedToPrelistings);
    } else {
      SortFilter.updateCheckBoxLists();
    }

    // Colors
    ColorCarousel.init();

    // Variants images Carouse
    $('.card-owl-carousel').owlCarousel({
      items: 1,
      dots: false,
      nav: true,
      margin: 0
    });

    // Images ZOOM-IN
    UI.zoomInInitGallery('zoomimage', `.img-box`);

    UI.unblock('#page');
  };

  let reloadPageWithClearingSelectAll = () => {
    App.pageData('selectAllListing', false);
    App.pageData('selectListing', []);
    reloadPage();
  };

  let reloadPage = () => {
    App.ajaxAbortAll();
    UI.block('#page');
    let selectAllListing = App.pageData('selectAllListing') || false;
    let selectListing = App.pageData('selectListing') || [];
    $.when(App.ajaxData(`listings/filter`, {}, 'POST')).done((pageData) => {
      // Mapping Page Data
      pageData.data = mapping.listings(pageData.data);
      pageData.isLicensor = $isLicensor;

      let template = require('./tmpl/partial/content.hbs');
      UI.render('#pageContentListings', template, pageData).then(() => {
        App.pageData('selectAllListing', selectAllListing);
        App.pageData('selectListing', selectListing);
        pageinit(true);
      });
    });
  };

  let handleBOMsubmit = (e) => {
    let selectListing;
    let target = $(e.target).hasClass('js-action-submitbom')
      ? $(e.target)
      : $(e.target).closest('.js-action-submitbom');
    let type = target.data('submittype');
    let card = target.closest('.card-item');

    if (!card.length || !card.data('itemid')) {
      selectListing = App.pageData('selectListing');
    } else {
      const listing = (App.pageData('data') || []).find(l => l.id === card.data('itemid'));
      selectListing = [{ id: listing.id, accountId: listing.accountId }];
    }

    if (!type || !selectListing.length) return;

    let idsCollection = selectListing.reduce((acc, item) => {
      acc[item.id] = item.accountId;

      return acc;
    }, {});

    BOM.submit(idsCollection, type, 'Listing');
  };

  let artworkInfoDialog = (e) => {
    let id = $(e.target).data('id') || false;

    let pageData = App.pageData('data') || [];

    const accountId = pageData.find(p => p?.assets?.some(a => a.objectId === id))?.accountId;

    if (!id || !accountId) return;
    ArtworkInfo.dialog(id, reloadPage, false, accountId);
  };

  let blankInfoDialog = (e) => {
    let id = $(e.target).data('id') || false;
    if (!id) return;
    BlankInfo.dialog(id, reloadPage, true);
  };

  let productInfoDialog = (e) => {
    let thisEl = $(e.target).hasClass('card-item') ? $(e.target) : $(e.target).closest('.card-item');
    let id = thisEl.data('itemid');
    if (!id) {
      return;
    }

    ProductInfo.dialog(id, {
      pageUrl: 'listings',
      accountId: User.accountID(),
      colorsDisabled: true,
      buttons: {
        storeData: true,
        productionData: true,
        delete: deleteListings
      }
    });
  };

  let folderDialog = (e) => {
    const target = $(e.target).hasClass('js-action-folderdialog')
      ? $(e.target)
      : $(e.target).closest('.js-action-folderdialog');
    const cardid = target.data('id');
    const action = target.data('action');
    const directory = target.data('directory');
    if (!cardid || !directory) {
      return;
    }
    const logAction = action === 'logfolder';

    const cardData = App.pageData('data').find((card) => card.id === cardid);
    if (!cardData) {
      return;
    }

    const data = mapping.folderDialog(cardData, directory);
    if (!data) {
      return;
    }

    if ($(e.target).hasClass('js-action-folder-error')) {
      folderErrorDialog(cardData, data);
      return;
    }

    if (directory !== 'bomfolderproduct' && !$(e.target).hasClass('js-action-folder-link')) {
      return;
    }

    if (logAction) {
      MockupSubmission.init('mockupSubmissionModal', data);
    } else {
      MockupStatus.init('mockupStatusModal', data);
    }
  };

  let downloadFilesForPersonalization = (e) => {
    const listingId = e.target.closest('[data-listingid]').getAttribute('data-listingid');

    UI.blockPage();

    Common.saveFile(
      $config.apiURL + `MasterProductData/download/${User.accountID()}/${listingId}/images`,
      `listing-images-${listingId}`,
    );
  };

  let moveToPrelistings = (e) => {
    const listingId = e.target.closest('[data-listingid]').getAttribute('data-listingid');
    UI.block('#page');
    toggleState([listingId], 'listings', reloadPage);
  };

  let moveSelectedToPrelistings = () => {
    let selected = App.pageData('selectListing');
    if (!selected?.length) {
      return;
    }

    UI.block('#page');
    toggleState(selected.map((s) => s.id), 'listings', reloadPageWithClearingSelectAll);
  };

  let folderErrorDialog = (cardData, directoryData) => {
    submissionDirectoryErrorModal.init('submissionDirectoryErrorModal', {
      title: cardData.title,
      thumbnailImageUri: cardData.thumbnailImageUri,
      standartId: cardData.standartId,
      createDate: directoryData.createdDate,
      directoryName: directoryData.directoryName,
      statusMessage: directoryData.statusMessage
    });
  };

  let deleteListings = () => {
    let selectListing = App.pageData('selectListing');

    if (!selectListing) return;

    const ids = selectListing.reduce((acc, item) => ({ ...acc, [item.id]: item.accountId }), {});

    bootbox.confirm(`<h4 class="text-danger font-weight-bold">${$Lang.alert.WantDelete}?</h4>`, (yes) => {
      if (!yes) return;

      bootbox.hideAll();

      UI.block('#page');
      $.when(App.ajaxData('listings/delete', { ids: ids, isConfirm: true }, 'POST')).done((res) => {
        App.pageData('selectListing', []);
        App.pageData('selectAllListing', false);

        reloadPage();
      });
    });
  };

  let selectAll = (event) => {
    let isCheked = $(event.currentTarget).prop('checked');
    App.pageData('selectAllListing', isCheked);

    if (!isCheked) {
      App.pageData('selectListing', []);
      return;
    }

    UI.block('#page');
    $.when(App.ajaxData(`listings/select/all/${User.accountID()}`, {}, 'POST'))
      .done((res) => {
        App.pageData('selectListing', res.data);
        selectListingPostHandler();
      })
      .always(() => {
        UI.unblock('#page');
      });
  };

  let selectListingPostHandler = () => {
    const data = App.pageData('data') || [];
    const selectListing = App.pageData('selectListing') || [];

    if (selectListing.length > data.length) {
      App.pageData('selectListingInOnePage', false);

      return;
    }

    const selectListingInOnePage = selectListing.every((sl) => data.some((d) => d.id === sl.id));

    App.pageData('selectListingInOnePage', selectListingInOnePage);
  };

  let masterProductDataPage = (id) => {
    MasterProductData.init(id, User.accountID(), lastQuery);
  };

  let isPostponedByLostSelectionDialog = (params = {}, query = '') => {
    if (!query) {
      return false;
    }

    const selectListing = App.pageData('selectListing');

    if (selectListing?.length && lastQuery.query !== query) {
      lostSelectionDialog((result) => {
        if (!result) {
          history.back();
          return;
        }

        App.pageData('selectListing', []);
        init(params, query);
      });
      return true;
    }

    return lastQuery.query === query;
  };

  let lostSelectionDialog = (callback = false) => {
    if (!callback) {
      return;
    }

    bootbox.dialog({
      title: 'Selection will be lost',
      closeButton: false,
      message: `<h5>Are you sure you want to leave this page?<br>The selection will be lost.</h5>`,
      className: 'modal-danger',
      buttons: {
        Ok: {
          label: 'OK',
          className: 'btn btn-danger',
          callback: function () {
            callback(true);
          }
        },
        Cancel: {
          label: 'Cancel',
          className: 'btn btn-link',
          callback: function () {
            callback(false);
          }
        }
      }
    });
  };

  let clear = () => {
    lastQuery = {};
  };

  let toggleState = (ids = [], type = 'listings', callback) => {
    $.ajax({
      type: 'post',
      url: `${$config.apiURL}${type}/toggle-state`,
      data: JSON.stringify(ids),
      dataType: 'json',
      contentType: 'application/json',
      crossDomain: true,
      async: true,
      headers: App.ajaxHeaders(),
      complete: () => {
        UI.notify({ text: $lang.alert.SuccessfullySaved, type: 'success' });
        callback?.();
      }
    });
  };

  return {
    init,
    clear,
    pageinit,
    folderDialog,
    deleteListings,
    selectAll,
    selectListingPostHandler,
    toggleState,
  };
})();
